(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.shtoBeforeAfter) return;
      root.shtoBeforeAfter = true;
      var cards = root.querySelector('.shto-before-after__cards');
      var progress = root.querySelector('.shto-before-after__progress');
      var bar = root.querySelector('.shto-before-after__bar');
      var dots = root.querySelectorAll('.shto-before-after__dot-nav');
      var dotsWrap = root.querySelector('.shto-before-after__dots');
      var arrows = root.querySelectorAll('.shto-before-after__arrow');
      var cta = root.querySelector('.shto-before-after__cta');

      if (cta) {
        cta.addEventListener('click', function (event) {
          var href = cta.getAttribute('href') || '';
          if (href.charAt(0) !== '#' || href.length < 2) return;
          var target = document.getElementById(decodeURIComponent(href.slice(1)));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', href);
        });
      }

      if (!cards) return;
      function step() {
        var first = cards.children[0];
        var second = cards.children[1];
        if (!first) return cards.clientWidth;
        return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
      }
      function update() {
        var max = cards.scrollWidth - cards.clientWidth;
        var scrolls = max > 1;
        if (scrolls) cards.setAttribute('tabindex', '0'); else cards.removeAttribute('tabindex');
        if (progress) progress.hidden = !scrolls;
        if (dotsWrap) dotsWrap.hidden = !scrolls;
        arrows.forEach(function (a) { a.hidden = !scrolls; });
        if (!scrolls) return;
        if (progress && bar) {
          var travel = progress.clientWidth - bar.offsetWidth;
          bar.style.transform = 'translateX(' + (cards.scrollLeft / max) * travel + 'px)';
        }
        if (dots.length) {
          var index = cards.scrollLeft >= max - 1 ? dots.length - 1 : Math.round(cards.scrollLeft / step());
          index = Math.max(0, Math.min(dots.length - 1, index));
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
            if (i === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
          });
        }
      }
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          var dir = a.classList.contains('shto-before-after__arrow--prev') ? -1 : 1;
          cards.scrollBy({ left: dir * step(), behavior: 'smooth' });
        });
      });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          cards.scrollTo({ left: i * step(), behavior: 'smooth' });
        });
      });
      cards.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll(scope) {
      scope.querySelectorAll('[data-shto-section="shto-before-after"]').forEach(init);
    }
    initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-guarantee-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.shtoGuaranteeCardScroll) return;
    window.shtoGuaranteeCardScroll = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-section="shto-guarantee-card"] [data-shto-scroll-link]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      // Blushe's theme (assets/global.js) writes every # link into the address bar and jumps there again on every
      // reload, so the page would open at the buy box. Handled here first, in the capture phase, and stopped.
      event.stopPropagation();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-guarantee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.shtoGuaranteeScroll) return;
    window.shtoGuaranteeScroll = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-section="shto-guarantee"] [data-shto-scroll-link]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.shtoHeroSplitScroll) return;
    window.shtoHeroSplitScroll = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-section="shto-hero-split"] [data-shto-scroll-link]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      // Blushe's theme (assets/global.js) writes every # link into the address bar and jumps there again on every
      // reload, so the page would open at the buy box. Handled here first, in the capture phase, and stopped.
      event.stopPropagation();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.shtoHowItWorks) return;
      root.shtoHowItWorks = true;
      var cards = root.querySelector('.shto-how-it-works__points');
      var progress = root.querySelector('.shto-how-it-works__progress');
      var bar = root.querySelector('.shto-how-it-works__bar');
      if (!cards) return;
      function update() {
        var max = cards.scrollWidth - cards.clientWidth;
        var scrolls = max > 1;
        if (progress) progress.hidden = !scrolls;
        if (!scrolls || !progress || !bar) return;
        var travel = progress.clientWidth - bar.offsetWidth;
        bar.style.transform = 'translateX(' + (cards.scrollLeft / max) * travel + 'px)';
      }
      cards.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll(scope) {
      scope.querySelectorAll('[data-shto-section="shto-how-it-works"]').forEach(init);
    }
    initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-icon-marquee"] && !Shopify.designMode) return;
  try {
    
  /* Pauses a moving strip ([data-shto-loop]) while it is scrolled out of view. Runs only when a strip enters or
     leaves the screen, never on every frame. Shared with key-features and why-this-brand: the first one to load sets it up. */
  (function () {
    if (window.ShtoLoopPause || !('IntersectionObserver' in window)) return;
    window.ShtoLoopPause = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.removeAttribute('data-shto-offscreen');
        else entry.target.setAttribute('data-shto-offscreen', '');
      });
    }, { rootMargin: '200px 0px' });
    function watch() { document.querySelectorAll('[data-shto-loop]').forEach(function (el) { window.ShtoLoopPause.observe(el); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.shto-ingredients a[data-shto-scroll]');
    if (!link) return;
    const hash = link.getAttribute('href') || '';
    if (!hash.startsWith('#') || hash.length < 2) return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', hash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-key-features"] && !Shopify.designMode) return;
  try {
    
  /* Pauses a moving strip ([data-shto-loop]) while it is scrolled out of view. Runs only when a strip enters or
     leaves the screen, never on every frame. Shared by key-features and why-this-brand: the first one to load sets it up. */
  (function () {
    if (window.ShtoLoopPause || !('IntersectionObserver' in window)) return;
    window.ShtoLoopPause = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.removeAttribute('data-shto-offscreen');
        else entry.target.setAttribute('data-shto-offscreen', '');
      });
    }, { rootMargin: '200px 0px' });
    function watch() { document.querySelectorAll('[data-shto-loop]').forEach(function (el) { window.ShtoLoopPause.observe(el); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-ladder-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Same slider script as shto-product-buy (a gallery is set up once, whichever copy runs first).
    function initGallery(gallery) {
      if (gallery.shtoGallery) return;
      gallery.shtoGallery = true;
      var track = gallery.querySelector('[data-shto-gallery-track]');
      var strip = gallery.querySelector('[data-shto-gallery-thumbs]');
      var slides = gallery.querySelectorAll('[data-shto-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-shto-gallery-thumb]');
      if (!track || slides.length < 2) return;
      var current = 0;
      function mark(index) {
        current = index;
        thumbs.forEach(function (thumb, i) {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        var thumb = thumbs[index];
        if (strip && thumb) {
          var left = thumb.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollTo({ left: left, behavior: 'auto' });
          else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: left + thumb.offsetWidth - strip.clientWidth, behavior: 'auto' });
        }
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          mark(i);
          track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
        });
      });
      function go(index) {
        index = (index + slides.length) % slides.length;
        mark(index);
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
      }
      gallery.querySelectorAll('[data-shto-gallery-step]').forEach(function (arrow) {
        arrow.addEventListener('click', function () { go(current + Number(arrow.dataset.shtoGalleryStep)); });
      });
      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current && slides[index]) mark(index);
      }, { passive: true });
    }
    function initAll() { document.querySelectorAll('[data-shto-gallery]').forEach(initGallery); }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-photo-quotes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktop = window.matchMedia('(min-width: 990px)');
    function init(root) {
      if (root.shtoPhotoQuotes) return;
      root.shtoPhotoQuotes = true;
      var cards = root.querySelector('.shto-photo-quotes__cards');
      var progress = root.querySelector('.shto-photo-quotes__progress');
      var bar = root.querySelector('.shto-photo-quotes__bar');
      if (!cards) return;
      var touched = false;
      function update() {
        var max = cards.scrollWidth - cards.clientWidth;
        var scrolls = max > 1;
        if (progress) progress.hidden = !scrolls;
        if (!scrolls || !progress || !bar) return;
        var travel = progress.clientWidth - bar.offsetWidth;
        bar.style.transform = 'translateX(' + (Math.min(cards.scrollLeft, max) / max) * travel + 'px)';
      }
      function start() {
        if (touched) return;
        var list = cards.children;
        var index = desktop.matches ? Math.max(1, parseInt(root.getAttribute('data-start'), 10) || 1) : 1;
        index = Math.min(index, list.length);
        var max = Math.max(0, cards.scrollWidth - cards.clientWidth);
        var left = list.length ? list[index - 1].offsetLeft - list[0].offsetLeft : 0;
        cards.scrollLeft = Math.min(max, Math.max(0, left));
        update();
      }
      cards.addEventListener('pointerdown', function () { touched = true; });
      cards.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (desktop.addEventListener) desktop.addEventListener('change', start);
      start();
    }
    function initAll(scope) {
      scope.querySelectorAll('[data-shto-section="shto-photo-quotes"]').forEach(init);
    }
    initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-product-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(gallery) {
      if (gallery.shtoGallery) return;
      gallery.shtoGallery = true;
      var track = gallery.querySelector('[data-shto-gallery-track]');
      var strip = gallery.querySelector('[data-shto-gallery-thumbs]');
      var slides = gallery.querySelectorAll('[data-shto-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-shto-gallery-thumb]');
      if (!track || slides.length < 2) return;
      var current = 0;
      function mark(index) {
        current = index;
        thumbs.forEach(function (thumb, i) {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        var thumb = thumbs[index];
        if (strip && thumb) {
          var left = thumb.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollTo({ left: left, behavior: 'auto' });
          else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: left + thumb.offsetWidth - strip.clientWidth, behavior: 'auto' });
        }
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          mark(i);
          track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
        });
      });
      function go(index) {
        index = (index + slides.length) % slides.length;
        mark(index);
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
      }
      gallery.querySelectorAll('[data-shto-gallery-step]').forEach(function (arrow) {
        arrow.addEventListener('click', function () { go(current + Number(arrow.dataset.shtoGalleryStep)); });
      });
      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current && slides[index]) mark(index);
      }, { passive: true });
    }
    function initAll() { document.querySelectorAll('[data-shto-gallery]').forEach(initGallery); }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-soft-close"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.shtoSoftCloseScroll) return;
    window.shtoSoftCloseScroll = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-section="shto-soft-close"] [data-shto-scroll-link]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      // Blushe's theme (assets/global.js) writes every # link into the address bar and jumps there again on every
      // reload, so the page would open at the buy box. Handled here first, in the capture phase, and stopped.
      event.stopPropagation();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var cards = root.querySelector('[data-shto-testimonials-cards]');
      var progress = root.querySelector('.shto-testimonials__progress');
      if (!cards || !progress || cards.shtoReady) return;
      cards.shtoReady = true;
      var queued = false;
      function update() {
        queued = false;
        var max = cards.scrollWidth - cards.clientWidth;
        progress.style.visibility = max > 1 ? '' : 'hidden';
        progress.style.setProperty('--p', max > 1 ? Math.min(1, Math.max(0, cards.scrollLeft / max)).toFixed(4) : 0);
      }
      function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
      cards.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }
    function init() { document.querySelectorAll('[data-shto-section="shto-testimonials"]').forEach(setup); }
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-why-this-brand"] && !Shopify.designMode) return;
  try {
    
  /* Pauses a moving strip ([data-shto-loop]) while it is scrolled out of view. Runs only when a strip enters or
     leaves the screen, never on every frame. Shared by key-features and why-this-brand: the first one to load sets it up. */
  (function () {
    if (window.ShtoLoopPause || !('IntersectionObserver' in window)) return;
    window.ShtoLoopPause = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.removeAttribute('data-shto-offscreen');
        else entry.target.setAttribute('data-shto-offscreen', '');
      });
    }, { rootMargin: '200px 0px' });
    function watch() { document.querySelectorAll('[data-shto-loop]').forEach(function (el) { window.ShtoLoopPause.observe(el); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();
})();
